import { useAppSelector } from '@app/store/store';
import { useMemo } from 'react';

import { DEFAULT_VIDEO_BG_COLOR } from '../../../../const';
import {
  selectActiveEditAspectRatio,
  selectActiveEditBackgroundColor,
  selectActiveEditPresetId,
  selectColorPresets,
} from '../../../../selector';
import { getClipPresetBackgroundColor } from '../../../../utils';

/**
 * Edit-view equivalent of {@link usePortraitBackground} — reads layout from
 * `activeEdit.draft` instead of V1 global recording state.
 */

export const useEditPortraitBackground = () => {
  const aspectRatio = useAppSelector(selectActiveEditAspectRatio);
  const backgroundColor = useAppSelector(selectActiveEditBackgroundColor);
  const presetId = useAppSelector(selectActiveEditPresetId);
  const presets = useAppSelector(selectColorPresets);
  const isPortrait = aspectRatio === '9_16';

  /** `null` on draft.backgroundColor means blur mode (same as V1 video background). */
  const isBlurMode = isPortrait && backgroundColor === null;

  const portraitBgColor = useMemo(() => {
    if (typeof backgroundColor === 'string') {
      return backgroundColor;
    }
    return (
      getClipPresetBackgroundColor(presetId, presets) ?? DEFAULT_VIDEO_BG_COLOR
    );
  }, [backgroundColor, presetId, presets]);

  return {
    isPortrait,
    isBlurMode,
    portraitBgColor,
  };
};
